import config from "lib/fr-config";

const { ADDRESS, OUTFIT_IMAGE, ITEM_IMAGE, PROFILE_IMAGE } = config.s3;

const getImgUrl = (type, filename) => {
  if (!filename) return null;
  switch (type) {
    case "outfit":
      return `${ADDRESS}/${OUTFIT_IMAGE}/${filename}`;
    case "item":
      return `${ADDRESS}/${ITEM_IMAGE}/${filename}`;
    case "profile":
      return `${ADDRESS}/${PROFILE_IMAGE}/${filename}`;

    default:
      console.log("error");
      console.error("error");
      break;
  }
};

export { getImgUrl };
